import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import contactPortalService from '../services/contactPortal';
import { useAuth } from '../contexts/AuthContext';
import ContactPortalShell from '../components/contact/ContactPortalShell';
import './ContactPortal.scss';

const ContactTasksList = () => {
  const navigate = useNavigate();
  const { user, fetchUser, setUser } = useAuth();

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError('');
        const data = await contactPortalService.getTasks();
        setTasks(data);
      } catch (err) {
        setError('No se pudieron cargar las tareas.');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const filteredTasks = useMemo(() => {
    const term = search.trim().toLowerCase();
    return tasks.filter((task) => {
      const title = (task.title || '').toLowerCase();
      const status = (task.status?.name || '').toLowerCase();
      const category = (task.category_name || '').toLowerCase();
      const formName = (task.form_name || '').toLowerCase();
      return (
        title.includes(term)
        || status.includes(term)
        || category.includes(term)
        || formName.includes(term)
      );
    });
  }, [tasks, search]);

  const onLogout = async () => {
    try {
      await contactPortalService.logout();
    } finally {
      setUser(null);
      await fetchUser();
      window.location.href = '/contactos/login';
    }
  };

  return (
    <ContactPortalShell
      user={user}
      onLogout={onLogout}
      searchValue={search}
      onSearchChange={setSearch}
    >
      <div className="inbox-list-only">
        <aside className="inbox-list-pane">
          <div className="pane-top-action">
            <Link to="/consultas-y-reclamos/create" className="btn btn-primary btn-new-top">Nueva consulta</Link>
          </div>

          <div className="pane-title-row">
            <div className="pane-title">Bandeja ({filteredTasks.length})</div>
          </div>

          {loading && <div className="pane-empty">Cargando gestiones...</div>}
          {error && <div className="error-message pane-empty">{error}</div>}

          {!loading && !error && filteredTasks.length === 0 && (
            <div className="pane-empty">No encontramos gestiones con ese criterio.</div>
          )}

          {!loading && !error && filteredTasks.length > 0 && (
            <div className="inbox-table-wrap">
              <table className="inbox-table">
                <thead>
                  <tr>
                    <th>Titulo</th>
                    <th>Categoria</th>
                    <th>Formulario</th>
                    <th>Estado</th>
                    <th>No leidos</th>
                    <th>Creado</th>
                    <th>Actualizado</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTasks.map((task) => (
                    <tr
                      key={task.id}
                      className="inbox-table-row"
                      onClick={() => navigate(`/consultas-y-reclamos/${task.id}`)}
                    >
                      <td>{task.title || 'Sin titulo'}</td>
                      <td>{task.category_name || 'No especificada'}</td>
                      <td>{task.form_name || 'No especificado'}</td>
                      <td>
                        <span className="row-status">{task.status?.name || 'Sin estado'}</span>
                      </td>
                      <td>{task.unread_chat_count || 0}</td>
                      <td>{new Date(task.created_at).toLocaleDateString('es-AR')}</td>
                      <td>{new Date(task.updated_at).toLocaleDateString('es-AR')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </aside>
      </div>
    </ContactPortalShell>
  );
};

export default ContactTasksList;
